// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2KnMo","label":"SetPasswdForm_label__3gYoo"};